<template>
    <div class="s-device">
        <el-checkbox v-model="searchObj.checkAll" @change="handleCheck" :indeterminate="searchObj.isIndeterminate" style="margin-left: -1px;"></el-checkbox>
        <el-select v-model="searchObj.devCatalog" style="width:110px">
            <el-option v-for="item in optionArray" :key="item.value" :label="item.label" :value="item.value">
                <span style="margin-right: 10px;">
                    <i :class="item.icon"></i>
                </span>
                <span>{{ item.label }}</span>
            </el-option>
        </el-select>
        <div class="search">
            <el-input type="text" style="width:110px" :placeholder="$t('integration.no_dot_/name')" v-model="searchObj.inputValue" clearable> </el-input>
            <el-button type="primary" icon="el-icon-search" class="btnClass" @click="searchDevie"></el-button>
        </div>
    </div>
</template>

<script>
import bus from '@/utils/bus';
export default {
    props: ['tableData', 'checkTableData', 'optionArray'],
    watch: {
        tableData(newVal) {
            if (newVal.length === 0) return (this.searchObj.checkAll = false), (this.searchObj.isIndeterminate = false);
            this.$nextTick(() => {
                const flag1 = (newVal || []).some(item => item.isChooze);
                this.searchObj.isIndeterminate = flag1;
                const flag2 = (newVal || []).every(item => item.isChooze);
                if (flag2) {
                    this.searchObj.checkAll = true;
                    this.searchObj.isIndeterminate = false;
                }
            });
        },
        checkTableData(newVal) {
            if (newVal.length === 0) {
                this.searchObj.isIndeterminate = false;
            } else {
                this.searchObj.isIndeterminate = true;
            }
        }
    },
    data() {
        return {
            searchObj: {
                checkAll: false,
                isIndeterminate: false,
                devCatalog: '',
                inputValue: ''
            }
        };
    },
    mounted() {
        // 单选情况下改变全选框
        bus.$on('SelectRow', obj => {
            this.searchObj.checkAll = obj.checkAll;
            this.searchObj.isIndeterminate = obj.isIndeterminate;
        });
        // 点击右侧删除会进行左侧的勾选取消  同时给一个方法改变半选全选框
        bus.$on('Indeterminate', array => {
            let flag = array.some(item => item.isChooze);
            (this.searchObj.checkAll = false), (this.searchObj.isIndeterminate = flag);
        });
    },
    beforeDestroy() {
        bus.$off('SelectRow');
        bus.$off('Indeterminate');
    },
    methods: {
        searchDevie() {
            this.$emit('searchDevie', this.searchObj);
        },
        handleCheck() {
            if (this.searchObj.isIndeterminate) {
                this.searchObj.checkAll = true;
                this.searchObj.isIndeterminate = false;
            }
            // 表格全选 or 全不选
            bus.$emit('selectAll', this.searchObj.checkAll);
        }
    }
};
</script>

<style lang="scss" scoped>
.s-device {
    width: 100%;
    height: 50px;
    padding: 5px;
    border-bottom: 1px solid $borderColor3;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .search {
        display: flex;
        align-items: center;
    }
}
</style>
